import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { useTheme } from '@emotion/react'
// import line from './../../assets/global/line.png';

const Title = ({ title, color = 'secondary.main', align= 'center' }) => {
    const themeM = useTheme();
    const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: align, gap:2, mb:2}} >
                <Typography variant={isMobile ? 'h6' : 'h5'} color={color} >{title}</Typography>
                {/* <CardMedia component={'img'}
                    src={line} sx={{ width: '200px' }} /> */}
            </Box>
        </>
    )
}

export default Title